"use client";

import { CaptionContainer } from "@piperunner-cms/component/RTERenderer/common";
import type { NodeProps } from "@tiptap/static-renderer/json/react";
import hljs from "highlight.js";
import { useRef } from "react";
import { useOnInView } from "react-intersection-observer";
import type { CodeBlockAttributes } from "../type";
import styles from "./CodeBlockNodeView.module.css";

import "highlight.js/styles/tokyo-night-dark.css";

export const CodeBlockNodeView = ({ node }: NodeProps) => {
  const highlightedMarkup = useRef<string>("");

  const containerRef = useOnInView(
    (inView) => {
      if (inView) {
        if (!highlightedMarkup.current) {
          highlightedMarkup.current = hljs.highlight(node.textContent, { language }).value;
        }

        if (ref.current) {
          ref.current.innerHTML = highlightedMarkup.current;
        }
      } else {
        ref.current.innerHTML = node.textContent;
      }
    },
    {
      threshold: 0,
      triggerOnce: false,
    },
  );

  const { caption, filename, language } = node.attrs as CodeBlockAttributes;
  const ref = useRef<HTMLElement>(null);

  return (
    <div className="node-codeBlock" ref={containerRef}>
      <CaptionContainer className="block-code" caption={caption}>
        <div className={styles.codeWrapper}>
          {/* File names here */}
          <div>{filename}</div>

          <pre className={styles.preWrapper}>
            <code ref={ref}>{node.textContent}</code>
          </pre>
        </div>
      </CaptionContainer>
    </div>
  );
};
